import Dexie from 'dexie'

const instance = new Dexie('chs')

export default instance
